import React from 'react';
import { PageLead } from './partials/PageLead';
import { PageLeadHeadline } from './partials/PageLeadHeadline';
import { PageLeadDescription } from './partials/PageLeadDescription';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PageLeadSkipLinks } from './partials/PageLeadSkipLinks';
import { PageLeadMetaInfo } from './partials/PageLeadMetaInfo';

export type PageLeadUser = {
  title: string;
  honorificPrefix?: 'mr' | 'ms' | 'mx' | 'na';
};

/**
 * User Page Lead in Person Profile Pages.
 */
export function PageLeadUser({ title, honorificPrefix }: PageLeadUser) {
  const { t } = useSonTranslation('UserRegistrationForm');

  return (
    <>
      <PageLead>
        <PageLeadHeadline>
          {honorificPrefix && honorificPrefix !== 'na' && honorificPrefix !== 'mx' && (
            <PageLeadDescription>{t(`inputs.honorificPrefix.options.${honorificPrefix}`)} </PageLeadDescription>
          )}
          {title}
          <PageLeadMetaInfo />
        </PageLeadHeadline>
      </PageLead>
      <PageLeadSkipLinks />
    </>
  );
}
